/**

 * @作者 王

 * @创建于 2021/5/18 15:05

 */
import CRUD from './CRUD/src/index';
import detailDialog from './detailDialog/src/index';
import editDialog from "./editDialog/src/index";
import editForm from './editForm/src/index'
import ljInput from './ljInput/src/index'
import paginationTable from "./paginationTable/src/index";
import viewDialog from './viewDialog/src/index'
import viewImage from './viewImage/src/index'
const components = {
    CRUD,
    detailDialog,
    editDialog,
    editForm,
    ljInput,
    paginationTable,
    viewDialog,
    viewImage
};

const install = function (Vue) {
    if (install.installed) return;
    Object.keys(components).forEach(key => {
        Vue.component(components[key].name, components[key])
    })
};
const API = {
    install,
    ...components
};
// 全局注册

export default API
